import './scss/bootstrap.scss';
import './scss/fontawesome.scss';
import './scss/spinao.scss';

import * as Lightgallery from '../assets-base/assets-src/js/Spinao/Lightgallery';
import * as Carousel from "../assets-base/assets-src/js/bootstrap/carousel";
import * as Dropdown from "../assets-base/assets-src/js/bootstrap/dropdown";
import * as Collapse from "../assets-base/assets-src/js/bootstrap/collapse";
import '../assets-base/assets-src/js/Spinao/HoverDisplay';
import * as AnimatedAnchors from '../assets-base/assets-src/js/Spinao/AnimatedAnchors';
import * as AnchorActivation from '../assets-base/assets-src/js/Spinao/AnchorActivation';
import BSCustomFileInput from '../assets-base/assets-src/js/bootstrap/CustomFileUpload/index';
import * as StickyTopMenu from '../assets-base/assets-src/js/Spinao/StickyTopMenu';
import * as UnifyHeight from '../assets-base/assets-src/js/Spinao/UnifyHeight';
import * as BackToTop from '../assets-base/assets-src/js/Spinao/BackToTop';
import * as EUCookie from '../assets-base/assets-src/js/Spinao/EUCookie';
import * as GoogleMaps from '../assets-base/assets-src/js/Spinao/GoogleMaps';
import * as GoogleReCaptcha from '../assets-base/assets-src/js/Spinao/GoogleReCaptcha';
import * as Offside from '../assets-base/assets-src/js/offside';
import * as NetteAjaxForm from '../assets-base/assets-src/js/Spinao/NetteAjaxForm';
import * as ClassSwitch from "../assets-base/assets-src/js/Spinao/ClassSwitch";
import * as DatePicker from "../assets-base/assets-src/js/Spinao/DatePicker";

document.addEventListener("DOMContentLoaded", function() {
    ClassSwitch.run();
    AnimatedAnchors.run();
    AnchorActivation.run();

    Offside.initialize('navbarCollapse', {
        buttonsSelector: '.js-offcanvas-trigger'
    });

    Lightgallery.applyTo('#js-lightgallery', {
        selector:'.js-lightgallery-image',
        fullScreen:false,
        zoom:false,
        hash:false,
        pager:false
    });

    StickyTopMenu.initialize();

    UnifyHeight.applyTo('.js-unify-height');
	UnifyHeight.applyDataAttribute();

    BackToTop.applyTo('backtotop_js');

    EUCookie.initialize();

    NetteAjaxForm.initialize('[data-ajax="form"]');

    BSCustomFileInput.init();

    GoogleMaps.initialize();
    GoogleReCaptcha.initialize();
    DatePicker.initialize();
});
